import { formatDate, DATETIME_FORMATS } from '@myap/ui-library/esm/date'
import { Loader, Error } from '../../../common'
import { fetchStudentSSDAccommodations } from '../../../../actions/studentSSDAccommodations'
import {
  selectSelectedApprovalRequest,
  selectApprovalRequestStatusProps,
} from '../../../../selectors/approvalRequests'
import { getSSDAccommodationsForStudent } from '../../../../selectors/studentSSDAccommodations'

const mapStateToProps = state => {
  const { fetching, error } = selectApprovalRequestStatusProps(state)
  const approvalRequest = selectSelectedApprovalRequest(state)
  const accommodations = getSSDAccommodationsForStudent(state, approvalRequest?.studentId)

  return {
    fetching,
    error,
    approvalRequest,
    accommodations,
  }
}

const ContentWrapper = ({ children }) => (
  <div className="row">
    <div className="col-xs-12" style={{ paddingBottom: '1.5em' }}>
      {children}
    </div>
  </div>
)

const SSDAccommodations = ({
  fetching,
  error,
  approvalRequest,
  accommodations,
  fetchStudentSSDAccommodations,
}) => {
  const { studentId } = approvalRequest
  const accommodationStyle = {
    padding: '15px 0',
    lineHeight: '1.2',
    borderTop: '1px dotted rgb(217, 217, 217)',
  }

  useEffect(() => {
    fetchStudentSSDAccommodations(studentId)
  }, [studentId])

  if (error) {
    return (
      <ContentWrapper>
        <Error message={error} />
      </ContentWrapper>
    )
  }

  if (fetching) {
    return (
      <ContentWrapper>
        <Loader />
      </ContentWrapper>
    )
  }

  if (accommodations?.length) {
    return (
      <ContentWrapper>
        {accommodations.map(ac => (
          <div style={accommodationStyle} key={ac.accommodationCode}>
            <div>{ac.accommodation}</div>
            {ac.comments && <div style={{ fontStyle: 'italic' }}>Comment: {ac.comments}</div>}
            {ac.expirationDate && (
              <div>
                Expiration Date: {formatDate(ac.expirationDate, DATETIME_FORMATS.longMonthDayYear)}
              </div>
            )}
          </div>
        ))}
      </ContentWrapper>
    )
  }

  return (
    <ContentWrapper>
      <p style={{ marginBottom: 0 }}>
        There are currently no approved accommodations associated with this student.
      </p>
    </ContentWrapper>
  )
}

export default connect(mapStateToProps, { fetchStudentSSDAccommodations })(SSDAccommodations)
